import React, { Component } from "react";
import PreformattedModal from "react/views/generic/PreformattedModal";
import PropTypes from "prop-types";
import { performJsonpGetRequest } from "lib/HttpRequest";
import { attachFunctionToCallback } from "utility";
import { appendCustomReplacementLinksToUrl } from "lib/UrlUtilities";

const articleDataRetrieved = "articleDataRetrievedCallback";

class ArticlesModalContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isModalLoading: false
		};
		this.onArticleDataRetrieved = this.onArticleDataRetrieved.bind(this);
	}
	componentWillReceiveProps(nextProps) {
		if (this.props.url !== nextProps.url) {
			this.setState({ isModalLoading: true });
            attachFunctionToCallback(this.onArticleDataRetrieved, articleDataRetrieved);
            let url = appendCustomReplacementLinksToUrl(nextProps.url);
			performJsonpGetRequest(url, articleDataRetrieved);
		}
	}
	onArticleDataRetrieved(data) {
		this.setState({ isModalLoading: false, modalContent: { __html: data.body, name: this.props.name } });
	}
	render() {
		return (
			<PreformattedModal
				item={this.state.modalContent}
				isLoading={this.state.isModalLoading}
				isOpen={this.props.isModalOpen}
				onClose={this.props.onModalClose}
			/>
		);
	}
}

ArticlesModalContainer.propTypes = {
	isModalOpen: PropTypes.bool,
	onModalClose: PropTypes.func.isRequired,
	name: PropTypes.string,
	url: PropTypes.string
};

export default ArticlesModalContainer;
export { articleDataRetrieved };



// WEBPACK FOOTER //
// ./src/react/containers/ArticlesModalContainer.jsx